import { render, staticRenderFns } from "./StockFirmReport.vue?vue&type=template&id=15864a02"
import script from "./StockFirmReport.vue?vue&type=script&lang=js"
export * from "./StockFirmReport.vue?vue&type=script&lang=js"
import style0 from "./StockFirmReport.vue?vue&type=style&index=0&id=15864a02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports